import { useQuery } from '@tanstack/react-query';
import { getServiceResource } from '@/enteties/project/api';
import { ResourceStatusCircles } from '@/enteties/project/ui/resource-status-circles';
import { ResourceStatusSkeleton } from '@/enteties/project/ui/resource-status-skeleton';
import { useMemo } from 'react';
import * as m from '@paraglide/messages';
interface ResourceStatusProps {
  slug: string;
}
export function ResourceStatus({
  slug
}: ResourceStatusProps) {
  const statusInfo = useMemo(() => ({
    NONE: {
      info: m.resource_status_NONE()
    },
    NO_DATA: {
      info: m.resource_status_NO_DATA()
    },
    RED: {
      info: m.resource_status_RED()
    },
    YELLOW: {
      info: m.resource_status_YELLOW()
    },
    GREEN: {
      info: m.resource_status_GREEN()
    }
  }), []);
  const {
    data,
    isSuccess
  } = useQuery({
    queryKey: ['resource-status', slug],
    queryFn: () => getServiceResource(slug)
  });
  if (!isSuccess) return <ResourceStatusSkeleton />;
  return <div className="flex flex-row items-center justify-start gap-2" data-sentry-component="ResourceStatus" data-sentry-source-file="resource-status.tsx">
      <ResourceStatusCircles status={data.status} data-sentry-element="ResourceStatusCircles" data-sentry-source-file="resource-status.tsx" />
      <p className="min-w-[200px] text-caption max-lg:hidden">
        {statusInfo[data.status].info}
      </p>
    </div>;
}